import { DateTime } from "luxon";
import { useState } from "react";
import { time_format_utils } from "../../../../../../common/time_format_utils";
import { RouterInferenceHelpers } from "../../../../../../src/api/trpc/rootRouter";
import { ModifySettingsButton } from "../base_components/modify_settings_button";
import { LogIcon } from "./guild_log_icon";
import { GuildLogText } from "./guild_log_text";
import { GuildLogTitle } from "./guild_log_title";
import { DetailsPane } from "./guild_log_page";

export function GuildLogItem(props: {
	log: RouterInferenceHelpers["guild_logs"]["get"]["output"]["logs"][0];
}) {
	const [is_showing_details, setShowDetails] = useState(false);

	return (
		<div
			className="flex cursor-pointer flex-col gap-0 border border-transparent bg-base-light hover:border-sesh-primary"
			onClick={() => setShowDetails(!is_showing_details)}
		>
			<div className="flex w-full items-center gap-4 p-4">
				<div>
					<LogIcon log_type={props.log.type} />
				</div>
				<div className="flex w-full min-w-0 flex-col gap-1">
					<div className="flex w-full min-w-0 flex-wrap items-center gap-4 text-xs text-content-secondary sm:flex-nowrap">
						<GuildLogTitle log={props.log} />
						<div className="ml-auto flex-shrink-0">
							{time_format_utils.format_time_concise_date_first(
								DateTime.fromJSDate(
									new Date(props.log.created_at)
								)
							)}
						</div>
					</div>
					<div className="flex items-center gap-4 text-sm sm:text-base">
						<GuildLogText
							log={props.log}
							is_expanded={is_showing_details}
						/>
					</div>
				</div>
				<button className="text-content-primary">
					<div key={is_showing_details.toString()}>
						{is_showing_details ? (
							<i className="fas fa-chevron-up"></i>
						) : (
							<i className="fas fa-chevron-down"></i>
						)}
					</div>
				</button>
			</div>
			{is_showing_details && <DetailsPane log={props.log} />}
		</div>
	);
}
